//=================================================
//    summary: DCP 檔案下載 視窗 -- Hook
//
//    remarks: 000 Tim 2021/11/17 Create
//             001 Tim 2021/12/23 加入 PaintedMe流程
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssResource from './Resource.module.scss'

import ResourceVolume from './Units/ResourceVolume/ResourceVolume'

import {LoadingMask, AlertWindow, ClientGatewayInPackage, GlobalLibs, NetworkLibs, PackageVariablesLibs} from 'bc-react-package'

// #region Const
const COMP_NAME = "Resource"

const MAX_CODE_CHARACHERS = 4 // input Text 最大的數字限制
const DEFAULT_PDF_FILE_NAME = "Resource.pdf"
// #endregion Const

// #region Enumeration
const MenuTypeEnum = {
    "Redeemed": 1,
    "FreeResource": 2
}

export const ResourceTypeEnum = {
    "Textbook": 1,
    "Workbook": 2,
    "WorkbookAnswerKey": 3,
    "Assessment": 4,
    "Free": 5
}

const PackageTypeEnum = {
    "DCPResourceTextbook": 7,
    "DCPResourceWorkbook": 8,
    "DCPResourceWorkbookAnswerKey": 9,
    "DCPResourceAssessment": 10
}

const AuthorizedStatusEnum = {
    "SuccessAuthorized": 1,
    "CancelAuthorized": 2,
    "NoAuthorized": 3
}

const FreeResourceTypeEnum = {
    "Volume1": 1,
    "Volume2": 2,
    "Volume3": 3,
    "Volume4": 4,
    "EssentialQuestions": 5,
    "OnlineUser": 6,
    "BookUser": 7
}
// #endregion Enumeration

// #region State Member Variables
let mstrStateCode01InputValue = ""
let mstrStateCode02InputValue = ""
let mstrStateCode03InputValue = ""
let mstrStateCode04InputValue = ""
// #endregion State Member Variables

// #region Member Variables
let mblnInitialized = false

let mstrDisplayName = ""
let mintAccountRole = 0
let mobjCallParam = null
let marrAuthorizedPackage = []
let mobjResource4FreeResource = null

let mstrDownloadFileName = ""

let mobjShowComponentParam = null
let mobjAuthorizedSubscription = null
// #endregion Member Variables


function Resource(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [menuType, setMenuType] = useState(MenuTypeEnum.Redeemed)
    const [authorizedDataTime, setAuthorizedDataTime] = useState(0)
    const [resourceDataTime, setResourceDataTime] = useState(0)

    const [code01InputValue, setCode01InputValue] = useState("")
    const [code02InputValue, setCode02InputValue] = useState("")
    const [code03InputValue, setCode03InputValue] = useState("")
    const [code04InputValue, setCode04InputValue] = useState("")

    const [isShowResourceVolume, setIsShowResourceVolume] = useState(false)
    
    const [showLoadingMask, setShowLoadingMask] = useState(false)
    const [loadingMaskMessage, setLoadingMaskMessage] = useState("")
    const [showAlert, setShowAlert] = useState(false)
    const [alertObject, setAlertObject] = useState(null)
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        mstrDisplayName = window.Globals.GetDisplayName()
        mintAccountRole = window.Globals.GetClassAccountRole(window.gSession.Acc.CurrentClassIndex)

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Update code01InputValue
    useEffect(() => {
        mstrStateCode01InputValue = code01InputValue
    }, [code01InputValue])

    // Update code02InputValue
    useEffect(() => {
        mstrStateCode02InputValue = code02InputValue
    }, [code02InputValue])

    // Update code03InputValue
    useEffect(() => {
        mstrStateCode03InputValue = code03InputValue
    }, [code03InputValue])

    // Update code04InputValue
    useEffect(() => {
        mstrStateCode04InputValue = code04InputValue
    }, [code04InputValue])

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false
            marrAuthorizedPackage = []
            mobjResource4FreeResource = null
            mstrDownloadFileName = ""
            mobjAuthorizedSubscription = null

            setAuthorizedDataTime(0)
            setResourceDataTime(0)
            setCode01InputValue("")
            setCode02InputValue("")
            setCode03InputValue("")
            setCode04InputValue("")
        }
    }, [])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 關閉
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function CloseOnTapHandler()
    {
        console.log(COMP_NAME + ".CloseOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        
        let objCallbackData = {
            "Action": "CloseShowResource"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseOnTapHandler

    /*===========================================
    summary: 點選 左邊選單
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function MenuButtonOnTapHandler(DisplayMenuType)
    {
        console.log(COMP_NAME + ".MenuButtonOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setMenuType(DisplayMenuType)
    } // end of MenuButtonOnTapHandler

    /*===========================================
    summary: 點選 授權碼 送出按鈕
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function SubmitOnTapHandler()
    {
        console.log(COMP_NAME + ".SubmitOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strCode01 = mstrStateCode01InputValue.trim()
        let strCode02 = mstrStateCode02InputValue.trim()
        let strCode03 = mstrStateCode03InputValue.trim()
        let strCode04 = mstrStateCode04InputValue.trim()

        console.log(COMP_NAME + ".SubmitOnTapHandler strCode01: ", strCode01)
        console.log(COMP_NAME + ".SubmitOnTapHandler strCode02: ", strCode02)
        console.log(COMP_NAME + ".SubmitOnTapHandler strCode03: ", strCode03)
        console.log(COMP_NAME + ".SubmitOnTapHandler strCode04: ", strCode04)

        if (
            (strCode01.length === 4) &&
            (strCode02.length === 4) &&
            (strCode03.length === 4) &&
            (strCode04.length === 4)
            )
        {
            let strCode = strCode01 + strCode02 + strCode03 + strCode04

            console.log("strCode: ", strCode)
            
            mobjCallParam = {
                "AuthCode": strCode
            }
            AuthProvisioning()
        }
        else 
        {
            let objAlertObject = {
                Header: "",
                Body: window.gAppUI.ERR_AuthorizationCode,
                ShowCloseButton: false,
                CallbackRef: null,
                Buttons: [
                    {
                        Text: PackageVariablesLibs.UISettings.BTN_OK,
                        AutoFocus: true
                    }
                ]
            }
            ShowAlert(objAlertObject)
        }
    } // end of SubmitOnTapHandler

    /*===========================================
    summary: 點選 資源 書本
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function RedeemedVolumeOnTapHandler(ButtonString, BookSeqNo, ResourceType)
    {
        console.log(COMP_NAME + ".RedeemedVolumeOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (ButtonString === window.gAppUI.BTN_View)
        {
            if (!window.navigator.onLine)
            {
                GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg)
            }
            else
            {
                mobjShowComponentParam = {
                    "BookSeqNo": BookSeqNo,
                    "ResourceType": ResourceType
                }
                setIsShowResourceVolume(true)
            }
        }
        else // this.ButtonTypeEnum.Buy
        {
            let strBookSeqNo = BookSeqNo.toString().PadLeft(2)

            NoAuthorizedProcess(window.gSession.App.BookCatID, strBookSeqNo, 0, 0)
        }
    } // end of RedeemedVolumeOnTapHandler

    /*===========================================
    summary: 點選 免費資源 書本
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function FreeResourceVolumeOnTapHandler(FreeResourceType)
    {
        console.log(COMP_NAME + ".FreeResourceVolumeOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let objResource = GetFileObject(FreeResourceType)

        if (objResource !== null)
        {
            let strFileName = objResource.FileName
            if (!window.gSession.App.InApp)
            {
                // Download
                WebDownloadFileProcess(strFileName)
            }
            else
            {
                // View
                AppViewPDFFileProcess(strFileName)
            }
        } // end of if (objResource !== null)
    } // end of FreeResourceVolumeOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    /*===========================================
    summary: Code 輸入框 改變事件
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function CodeChangeHandler(e, TextID)
    {
        console.log(COMP_NAME + ".CodeChangeHandler: ", e)

        switch (TextID) 
        {
            case 2:
                setCode02InputValue(e.target.value)
                break
            case 3:
                setCode03InputValue(e.target.value)
                break
            case 4:
                setCode04InputValue(e.target.value)
                break
            case 1:
            default:
                setCode01InputValue(e.target.value)
                break
        } // end of switch
    } // end of CodeChangeHandler
    // #endregion Other EventHandler

    // #region LoadingMask and Alert Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")
        setShowLoadingMask(true)
        setLoadingMaskMessage(LoadingMsg)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        setShowLoadingMask(false)
        setLoadingMaskMessage("")
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        setAlertObject(AlertObject)
        setShowAlert(true)
    } // end of ShowAlert

    /*===========================================
    summary: 關閉 提示視窗
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function HideAlert()
    {
        setAlertObject(null)
        setShowAlert(false)
    } // end of HideAlert
    // #endregion LoadingMask and Alert Functions

    // #region ComponentCallback
    /*===========================================
    summary: Component 的 Callback
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function ComponentCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".ComponentCallback CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "OpenLoadingMask")
        {
            OpenLoadingMask(CallbackObj.Message)
        } // end of if (CallbackObj.Action === "OpenLoadingMask") 
        else if (CallbackObj.Action === "CloseLoadingMask")
        {
            CloseLoadingMask()
        } // end of else if (CallbackObj.Action === "CloseLoadingMask") 
        else if (CallbackObj.Action === "ShowAlertWindow")
        {
            ShowAlert(CallbackObj.AlertObject)
        } // end of else if (CallbackObj.Action === "ShowAlertWindow") 
        else if (CallbackObj.Action === "CloseShowResourceVolume")
        {
            mobjShowComponentParam = null
            setIsShowResourceVolume(false)
        } // end of else if (CallbackObj.Action === "CloseShowResourceVolume")
    } // end of ComponentCallback
    // #endregion ComponentCallback

    // #region AlertCallBack
    /*===========================================
    summary: 授權 更新成功 Alert CallBack
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function SubmitSuccessAlertCallBack ()
    {
        console.log(COMP_NAME + ".SubmitSuccessAlertCallBack")
        
        mobjCallParam = {
            "DataType": 1,       // 1: DCPResource 相關 Package
            "UpdateAuthorized": true
        }
        GetAccountAuthorizedInfo()
    } // end of SubmitSuccessAlertCallBack

    /*===========================================
    summary: 點選 Lessons 沒有授權 直接開授權頁面
    remarks: 000 Tim 2021/11/29 Create
    ===========================================*/
    function NoAuthorizedGoToSubscriptionAlertCallBack (BtnObject)
    {
        console.log(COMP_NAME + ".NoAuthorizedGoToSubscriptionAlertCallBack: BtnObject: ", BtnObject)

        if (BtnObject.index === 1) // BTN_OK
        {
            let objCallbackData = {
                "Action": "OpenSettings4NoAuthorized",
                "AuthorizedSubscription": mobjAuthorizedSubscription
            }
            props.CallbackRef(objCallbackData)
        }
        else
        {
            // 取消的話，清空資料
            mobjAuthorizedSubscription = null
        }
    } // end of NoAuthorizedGoToSubscriptionAlertCallBack
    // #region AlertCallBack

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        mobjCallParam = {
            "DataType": 1,              // 1: DCPResource 相關 Package
            "UpdateAuthorized": false
        }
        GetAccountAuthorizedInfo()
    } // end of PaintedMe

    /*===========================================
    summary: 取得 選單按鈕 顯示物件
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function GetMenuButtonDisplayObject(DisplayMenuType)
    {
        let objDisplay = {
            "IconCls": null,
            "Text": ""
        }

        switch (DisplayMenuType)
        {
            case MenuTypeEnum.FreeResource:
                objDisplay.IconCls = cssResource.divFreeResourceIcon
                objDisplay.Text = window.gAppUI.LBL_FreeResource
                break
            case MenuTypeEnum.Redeemed:
            default:
                objDisplay.IconCls = cssResource.divRedeemedIcon
                objDisplay.Text = window.gAppUI.LBL_Redeemed
                break
        } // end of switch (DisplayMenuType)

        return objDisplay
    } // end of GetMenuButtonDisplayObject

    /*===========================================
    summary: 取得 AuthorizedBook 列表
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GetAuthorizedBookList (ResourceType)
    {
        let intPackageType = 0
        switch (ResourceType)
        {
            case ResourceTypeEnum.Textbook:
                intPackageType = PackageTypeEnum.DCPResourceTextbook
                break
            case ResourceTypeEnum.Workbook:
                intPackageType = PackageTypeEnum.DCPResourceWorkbook
                break
            case ResourceTypeEnum.WorkbookAnswerKey:
                intPackageType = PackageTypeEnum.DCPResourceWorkbookAnswerKey
                break
            case ResourceTypeEnum.Assessment:
                intPackageType = PackageTypeEnum.DCPResourceAssessment
                break
            default:
                break
        } // end of switch (ResourceType)

        let blnFound = false
        let intIndex = 0
        let intCount = marrAuthorizedPackage.length
        let arrAuthorizedBook = null

        while ((!blnFound) && (intIndex < intCount))
        {
            // console.log("marrAuthorizedPackage: ", marrAuthorizedPackage[intIndex], intIndex)
            if (intPackageType === parseInt(marrAuthorizedPackage[intIndex].PackageType))
            {
                blnFound = true
                arrAuthorizedBook = marrAuthorizedPackage[intIndex].AuthorizedBook
            } // end of if (intPackageType === parseInt(marrAuthorizedPackage[intIndex].PackageType))
            intIndex++
        } // end of while

        console.log(COMP_NAME + ".GetAuthorizedBookList arrAuthorizedBook: ", arrAuthorizedBook)
        
        return arrAuthorizedBook
    } // end of GetAuthorizedBookList

    /*===========================================
    summary: 沒有授權 的 後續流程，先走購買，再回到 原本選擇的Lesson
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function NoAuthorizedProcess (BookCatID, BookSeqNo, LessonID, LUCatSeqNo)
    {
        console.log(COMP_NAME + ".NoAuthorizedProcess: Not Authorized!")

        console.log(COMP_NAME + ".NoAuthorizedProcess: BookCatID: ", BookCatID)
        console.log(COMP_NAME + ".NoAuthorizedProcess: BookSeqNo: ", BookSeqNo)
        console.log(COMP_NAME + ".NoAuthorizedProcess: LessonID: ", LessonID)
        console.log(COMP_NAME + ".NoAuthorizedProcess: LUCatSeqNo: ", LUCatSeqNo)

        // 先不串 GoogleClass 配對這塊     Tim20.04.17
        let strBookSeqNo = BookSeqNo.toString().PadLeft(2)
        mobjAuthorizedSubscription = {
            "BookCatID": parseInt(BookCatID),
            "BookSeqNo": strBookSeqNo,
            "LessonID": LessonID,
            "LUCatSeqNo": parseInt(LUCatSeqNo),
            "SubscriptionType": window.gAuthorizedSubscriptionTypeEnum.Resource
        }
        
        let objAlertObject = {
            Header: "",
            Body: window.gAppUI.ERR_GoToLUNoAuthorizedGoToIAP,
            ShowCloseButton: false,
            CallbackRef: NoAuthorizedGoToSubscriptionAlertCallBack,
            Buttons: [
                {
                    Text: window.gAppUI.BTN_Cancel,
                    AutoFocus: false
                },
                {
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }
            ]
        }
        ShowAlert(objAlertObject)
    } // end of NoAuthorizedProcess

    /*===========================================
    summary: 取得 Redeemed Volume 顯示 物件
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GetRedeemedVolumeDisplayObject(AuthorizedBookList, BookSeqNo)
    {
        let objDisplay = {
            "Button": "　",
            "ExpireBy": "　",
            "Date": "　",
            "Time": "　"
        }

        let objAuthorizedBook = GetAuthorizedBook(AuthorizedBookList, BookSeqNo)

        let blnExpired = window.Globals.CheckAuthorized(window.gSession.Acc.AccountAuthorized, window.gSession.App.BookCatID, BookSeqNo)
        let objAuthorizedVolume = window.Globals.GetAuthorized(window.gSession.Acc.AccountAuthorized, window.gSession.App.BookCatID, BookSeqNo)

        console.log(COMP_NAME + ".GetRedeemedVolumeDisplayObject objAuthorizedBook: ", objAuthorizedBook)
        console.log(COMP_NAME + ".GetRedeemedVolumeDisplayObject objAuthorizedVolume: ", objAuthorizedVolume)

        let objAuthorized = null

        let arrExpired = []

        if (
            (parseInt(objAuthorizedBook.Status) === AuthorizedStatusEnum.SuccessAuthorized) ||
            (!blnExpired)
            )
        {
            let datOriginal = null
            let datVolume = null

            if (
                (objAuthorizedBook.ExpiredTime !== null) &&
                (objAuthorizedBook.ExpiredTime !== "") &&
                (objAuthorizedBook.ExpiredTime !== "2000-01-01 00:00:00")    // 這個代表後端設定 取消授權   Tim22.12.05
                )
            {
                datOriginal = new Date(objAuthorizedBook.ExpiredTime.replace(/-/g, '/'))
            }

            if (
                (objAuthorizedVolume.ExpiredTime !== null) &&
                (objAuthorizedVolume.ExpiredTime !== "") &&
                (objAuthorizedVolume.ExpiredTime !== "2000-01-01 00:00:00")    // 這個代表後端設定 取消授權   Tim22.12.05
                )
            {
                datVolume = new Date(objAuthorizedVolume.ExpiredTime.replace(/-/g, '/'))
            }

            if (
                (datOriginal != null) && 
                (datVolume == null)
                )
            {
                objAuthorized = objAuthorizedBook
            }
            else if (
                (datOriginal == null) && 
                (datVolume != null)
                )
            {
                objAuthorized = objAuthorizedVolume
            }
            else
            {
                if (datOriginal.valueOf() >= datVolume.valueOf())
                {
                    objAuthorized = objAuthorizedBook
                }
                else
                {
                    objAuthorized = objAuthorizedVolume
                }
            }

            if (
                (objAuthorized !== null) &&
                (objAuthorized.ExpiredTime !== null) &&
                (objAuthorized.ExpiredTime !== "") &&
                (objAuthorized.ExpiredTime !== "2000-01-01 00:00:00")    // 這個代表後端設定 取消授權   Tim22.12.05
                )
            {
                arrExpired = objAuthorized.ExpiredTime.split(" ")
                objDisplay.Date = arrExpired[0]
                objDisplay.Time = arrExpired[1]
            }

            objDisplay.Button = window.gAppUI.BTN_View
            objDisplay.ExpireBy = window.gAppUI.LBL_ExpireBy
        }
        else
        {
            objDisplay.Button = window.gAppUI.BTN_Buy
        }

        return objDisplay
    } // end of GetRedeemedVolumeDisplayObject

    /*===========================================
    summary: 取得 Free Resource Volume 顯示 物件
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function GetFreeResourceVolumeDisplayObject (FreeResourceType)
    {
        let objDisplay = {
            "Icon": null,
            "Title": "",
            "Button": ""
        }

        if (!window.gSession.App.InApp)
        {
            objDisplay.Button = window.gAppUI.BTN_Download
        }
        else
        {
            objDisplay.Button = window.gAppUI.BTN_View
        }

        switch (FreeResourceType) 
        {
            case FreeResourceTypeEnum.Volume2:
                objDisplay.Icon = cssResource.divWritingTemplateIcon02
                objDisplay.Title = window.gAppUI.LBL_Volume + " 2"
                break
            case FreeResourceTypeEnum.Volume3:
                objDisplay.Icon = cssResource.divWritingTemplateIcon03
                objDisplay.Title = window.gAppUI.LBL_Volume + " 3"
                break
            case FreeResourceTypeEnum.Volume4:
                objDisplay.Icon = cssResource.divWritingTemplateIcon04
                objDisplay.Title = window.gAppUI.LBL_Volume + " 4"
                break
            case FreeResourceTypeEnum.EssentialQuestions:
                objDisplay.Icon = cssResource.divEQIcon
                objDisplay.Title = window.gAppUI.LBL_EssentialQuestions
                break
            case FreeResourceTypeEnum.OnlineUser:
                objDisplay.Icon = cssResource.divPGOnlineIcon
                objDisplay.Title = window.gAppUI.LBL_PacingGuideOnline
                break
            case FreeResourceTypeEnum.BookUser:
                objDisplay.Icon = cssResource.divPGBookIcon
                objDisplay.Title = window.gAppUI.LBL_PacingGuideBook
                break
            case FreeResourceTypeEnum.Volume1:
            default:
                objDisplay.Icon = cssResource.divWritingTemplateIcon01
                objDisplay.Title = window.gAppUI.LBL_Volume + " 1"
                break
        } // end of switch (FreeResourceType)

        return objDisplay
    } // end of GetFreeResourceVolumeDisplayObject

    /*===========================================
    summary: 取得 AuthorizedBook 單一本
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GetAuthorizedBook (AuthorizedBookList, BookSeqNo)
    {
        // console.log(COMP_NAME + ".GetAuthorizedBook: ", AuthorizedBookList, BookSeqNo)

        let blnFound = false
        let intIndex = 0
        let intCount = AuthorizedBookList.length
        let objAuthorizedBook = null

        while ((!blnFound) && (intIndex < intCount))
        {
            if (BookSeqNo === parseInt(AuthorizedBookList[intIndex].BookSeqNo))
            {
                blnFound = true
                objAuthorizedBook = AuthorizedBookList[intIndex]
            } // end of if (BookSeqNo === parseInt(AuthorizedBookList[intIndex].BookSeqNo))
            intIndex++
        } // end of while
        
        return objAuthorizedBook
    } // end of GetAuthorizedBook

    /*===========================================
    summary: 取得 檔案 物件
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GetFileObject (FreeResourceType)
    {
        let strKeyWord = GetFileKeyWord(FreeResourceType)
        let intIndex = 0
        let intCount = mobjResource4FreeResource.FileList.length
        let blnFound = false
        let objResource = null

        while ((!blnFound) && (intIndex < intCount))
        {
            if (mobjResource4FreeResource.FileList[intIndex].Name.toLowerCase().indexOf(strKeyWord) !== -1)
            {
                objResource = mobjResource4FreeResource.FileList[intIndex]
                blnFound = true
            } // end of if (mobjResource4FreeResource.FileList[intIndex].Name.toLowerCase().indexOf(strKeyWord) !== -1)
            intIndex++
        } // end of while

        return objResource
    } // end of GetFileObject

    /*===========================================
    summary: 取得 檔案 KeyWord
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function GetFileKeyWord (FreeResourceType)
    {
        let strKeyWord = ""

        switch (FreeResourceType)
        {
            case FreeResourceTypeEnum.Volume2:
                strKeyWord = "v2"
                break
            case FreeResourceTypeEnum.Volume3:
                strKeyWord = "v3"
                break
            case FreeResourceTypeEnum.Volume4:
                strKeyWord = "v4"
                break
            case FreeResourceTypeEnum.EssentialQuestions:
                strKeyWord = "essential questions"
                break
            case FreeResourceTypeEnum.OnlineUser:
                strKeyWord = "online user"
                break
            case FreeResourceTypeEnum.BookUser:
                strKeyWord = "book user"
                break
            case FreeResourceTypeEnum.Volume1:
            default:
                strKeyWord = "v1"
                break
        } // end of switch (FreeResourceType)

        return strKeyWord
    } // end of GetFileKeyWord

    /*===========================================
    summary: Web 下載 PDF檔案 流程，增加隱藏網址 防盜機制
    remarks: 000 Tim 2023/04/19 Create
    ===========================================*/
    function WebDownloadFileProcess(FileName)
    {
        console.log(COMP_NAME + ".WebDownloadFileProcess: FileName: ", FileName)

        // // 網址顯示機制
        // let strDownloadUrl = PackageVariablesLibs.SysConfig.DownloadServer + FileName + '&FileType=3'
        // window.open(strDownloadUrl, '_parent')

        // 取得路經中的檔名及副檔名
        mstrDownloadFileName = FileName.replace(/^.*[/]/, '')
        console.log(COMP_NAME + ".WebDownloadFileProcess mstrDownloadFileName: ", mstrDownloadFileName)

        // Web 在這邊 顯示LoadingMask  讀取資料, 下載處理等等流程，最後才關閉
        // Open Loading mask with message
        OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetListeningPDFFileKeyFromFS)

        mobjCallParam = {
            "FileName": FileName
        }
        console.log(COMP_NAME + ".WebDownloadFileProcess mobjCallParam:", mobjCallParam)
        GetListeningPDFFileKeyFromFS()
    } // end of WebDownloadFileProcess

    /*===========================================
    summary: Web 使用 Blob 下載 PDF檔案
    remarks: 000 Tim 2023/04/19 Create
    ===========================================*/
    function ProcessFileDownloadWithBlob(OneTimeKey)
    {
        console.log(COMP_NAME + ".ProcessFileDownloadWithBlob: ", OneTimeKey)

        // let strURL = "https://appfsdev.betterchinese.com/main.php" + "?" + "Func=DownloadFile&DownloadKey=" + strOneTimeKey

        // 目前參數必須寫在 QueryString 無法用 JOSN Post丟過去
        let strURL = PackageVariablesLibs.SysConfig.BlobDownloadServer
        strURL += "?Func=DownloadFile" 
        strURL += "&DownloadKey=" + OneTimeKey
        
        fetch(
            strURL,
            {
                "method": 'POST'
            },
        )
            .then(function (response)
            {
                console.log(COMP_NAME + ".ProcessFileDownloadWithBlob response.type: ", response.type) // returns basic by default

                response.blob().then(function (objBlob)
                {
                    let objURL = URL.createObjectURL(objBlob)
                    console.log(COMP_NAME + ".ProcessFileDownloadWithBlob objURL: ", objURL)

                    let strFilename = DEFAULT_PDF_FILE_NAME
                    if (mstrDownloadFileName !== "")
                    {
                        strFilename = mstrDownloadFileName
                    } // end of if (mstrDownloadFileName !== "")

                    WebAutoDownload(strFilename, objURL)    
                });
            }) // end of then(function (response)
            .catch(error => {
                console.log(COMP_NAME + ".ProcessFileDownloadWithBlob fetch err: ", error)

                if (!window.gSession.App.InApp)
                {
                    // Web 發生錯誤 關閉 LoadingMask
                    CloseLoadingMask()
                } // end of if (!window.gSession.App.InApp)

                let objAlertObject = {
                    Header: null,
                    Body: window.gAppUI.ERR_DownloadFileFail,
                    ShowCloseButton: false,
                    CallbackRef: null,
                    Buttons: [
                        {
                            Text: PackageVariablesLibs.UISettings.BTN_OK,
                            AutoFocus: true
                        }
                    ]
                }
                ShowAlert(objAlertObject)
            }) // end of catch
    } // end of ProcessFileDownloadWithBlob

    /*===========================================
    summary: Web 自動下載
    remarks: 000 Tim 2023/04/19 Create
    ===========================================*/
    function WebAutoDownload(FileName, UrlObject)
    {
        console.log(COMP_NAME + ".WebAutoDownload: ")
        console.log(COMP_NAME + ".WebAutoDownload FileName: ", FileName)
        console.log(COMP_NAME + ".WebAutoDownload UrlObject: ", UrlObject)

        let objElement = document.createElement('a')
        objElement.setAttribute('href', UrlObject)
        objElement.setAttribute('download', FileName)
        objElement.style.display = 'none'
        document.body.appendChild(objElement)
        objElement.click()
        document.body.removeChild(objElement)

        if (!window.gSession.App.InApp)
        {
            // Web 發生錯誤 關閉 LoadingMask
            CloseLoadingMask()
        } // end of if (!window.gSession.App.InApp)
    } // end of WebAutoDownload

    /*===========================================
    summary: App 觀看 PDF檔案 流程
    remarks: 000 Tim 2023/04/19 Create
             001 Tim 2023/06/19 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function AppViewPDFFileProcess(FileName)
    {
        const FUNC_NAME = AppViewPDFFileProcess.name
        console.log(COMP_NAME + "." + FUNC_NAME + ": FileName: ", FileName)

        if (window.gSession.App.iOSNewGateway)
        {
            console.log(COMP_NAME + "." + FUNC_NAME + " SwiftUI")
            
            // 取得路經中的檔名及副檔名
            mstrDownloadFileName = FileName.replace(/^.*[/]/, '')
            console.log(COMP_NAME + "." + FUNC_NAME + " mstrDownloadFileName: ", mstrDownloadFileName)

            mobjCallParam = {
                "FileName": FileName
            }
            console.log(COMP_NAME + "." + FUNC_NAME + " mobjCallParam:", mobjCallParam)
            GetListeningPDFFileKeyFromFS()
        } // end of if (window.gSession.App.iOSNewGateway)
        else
        {
            console.log(COMP_NAME + "." + FUNC_NAME + " Not SwiftUI")

            let intPreX = 0
            let intPreY = 0

            let intAction = window.gConst.ACTION_OPEN_PDF
            let strQueryString = "Action=" + intAction
            strQueryString += "&Credential=" + window.gSession.Acc.Credential
            strQueryString += "&BackRoute="
            strQueryString += "&FN=" + FileName
            strQueryString += "&PosX=" + intPreX
            strQueryString += "&PosY=" + intPreY

            console.log(COMP_NAME + "." + FUNC_NAME + " strQueryString:", strQueryString)

            // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
            ClientGatewayInPackage.CallApp(strQueryString)
        } // end of else
    } // end of AppViewPDFFileProcess
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 Menu Button Cls
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GetMenuButtonCls(StateMenuType, DisplayMenuType)
    {
        let objCls = cssResource.divMenuButton

        if (StateMenuType === DisplayMenuType)
        {
            objCls = cssResource.divMenuButtonSelected
        }

        return objCls
    } // end of GetMenuButtonCls

    /*===========================================
    summary: 取得 書本 Icon Cls
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GetVolumeIconCls(ResourceType, BookSeqNo)
    {
        let objCls = ""

        switch (ResourceType)
        {
            case ResourceTypeEnum.Workbook:
                objCls = GetWorkbookIconCls(BookSeqNo)
                break
            case ResourceTypeEnum.WorkbookAnswerKey:
                objCls = GetAnswerKeyIconCls(BookSeqNo)
                break
            case ResourceTypeEnum.Assessment:
                objCls = GetAssessmentIconCls(BookSeqNo)
                break
            case ResourceTypeEnum.Textbook:
            default:
                objCls = GetTextbookIconCls(BookSeqNo)
                break
        } // end of switch (ResourceType)

        return objCls
    } // end of GetVolumeIconCls

    /*===========================================
    summary: 取得 Textbook書本 Icon Cls
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GetTextbookIconCls(BookSeqNo)
    {
        let objCls = ""

        switch (BookSeqNo)
        {
            case 2:
                objCls = cssResource.divTextBookIcon02
                break
            case 3:
                objCls = cssResource.divTextBookIcon03
                break
            case 4:
                objCls = cssResource.divTextBookIcon04
                break
            case 1:
            default:
                objCls = cssResource.divTextBookIcon01
                break
        } // end of switch (BookSeqNo)

        return objCls
    } // end of GetTextbookIconCls

    /*===========================================
    summary: 取得 Workbook書本 Icon Cls
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GetWorkbookIconCls(BookSeqNo)
    {
        let objCls = ""

        switch (BookSeqNo)
        {
            case 2:
                objCls = cssResource.divWorkBookAudioIcon02
                break
            case 3:
                objCls = cssResource.divWorkBookAudioIcon03
                break
            case 4:
                objCls = cssResource.divWorkBookAudioIcon04
                break
            case 1:
            default:
                objCls = cssResource.divWorkBookAudioIcon01
                break
        } // end of switch (BookSeqNo)

        return objCls
    } // end of GetWorkbookIconCls

    /*===========================================
    summary: 取得 Workbook AnswerKey書本 Icon Cls
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GetAnswerKeyIconCls(BookSeqNo)
    {
        let objCls = ""

        switch (BookSeqNo)
        {
            case 2:
                objCls = cssResource.divWorkBookAnswerKeyIcon02
                break
            case 3:
                objCls = cssResource.divWorkBookAnswerKeyIcon03
                break
            case 4:
                objCls = cssResource.divWorkBookAnswerKeyIcon04
                break
            case 1:
            default:
                objCls = cssResource.divWorkBookAnswerKeyIcon01
                break
        } // end of switch (BookSeqNo)

        return objCls
    } // end of GetAnswerKeyIconCls

    /*===========================================
    summary: 取得 Assessment書本 Icon Cls
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GetAssessmentIconCls(BookSeqNo)
    {
        let objCls = ""

        switch (BookSeqNo)
        {
            case 2:
                objCls = cssResource.divAssessmentIcon02
                break
            case 3:
                objCls = cssResource.divAssessmentIcon03
                break
            case 4:
                objCls = cssResource.divAssessmentIcon04
                break
            case 1:
            default:
                objCls = cssResource.divAssessmentIcon01
                break
        } // end of switch (BookSeqNo)

        return objCls
    } // end of GetAssessmentIconCls
    // #endregion Get ClassName

    // #region Web Service After Process
    /*===========================================
    summary: 取得下載PDF用的OntTimeKey 資料讀取完畢  iOSNewGateway下載流程
    remarks: 000 Tim 2023/04/19 Create
             001 Tim 2023/05/25 原 ACTION_OPEN_PDF: 18 -> ACTION_SHARE_FILE_WITH_ANOTHER: 40
             002 Tim 2023/06/19 CallApp前 清空 AppCallbackRef
             003 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function GetListeningPDFFileKeyFromFSAfterProcess(ReturnData)
    {
        const FUNC_NAME = GetListeningPDFFileKeyFromFSAfterProcess.name
        console.log(COMP_NAME + "." + FUNC_NAME + ": ", ReturnData)

        if (
            (ReturnData !== null) &&
            (typeof(ReturnData.FileList) !== "undefined") &&
            (ReturnData.FileList !== null) &&
            (Array.isArray(ReturnData.FileList)) &&
            (ReturnData.FileList.length > 0)
            )
        {
            let strOneTimeKey = ReturnData.FileList[0].OneTimeKey
            console.log(COMP_NAME + "." + FUNC_NAME + " strOneTimeKey:", strOneTimeKey)

            if (!window.gSession.App.InApp)
            {
                // Web
                ProcessFileDownloadWithBlob(strOneTimeKey)
            } // end of if (!window.gSession.App.InApp)
            else
            {
                // App

                // // 原 ACTION_OPEN_PDF: 18 -> ACTION_SHARE_FILE_WITH_ANOTHER: 40
                // let intAction = window.gConst.ACTION_OPEN_PDF
                // let strQueryString = "Action=" + intAction
                // strQueryString += "&Credential=" + window.gSession.Acc.Credential
                // strQueryString += "&BackRoute="
                // strQueryString += "&DownloadOneTimeKey=" + strOneTimeKey
                // strQueryString += "&FileName=" + mstrDownloadFileName

                let strFileUrl = PackageVariablesLibs.SysConfig.BlobDownloadServer
                strFileUrl += "?Func=DownloadFile"
                strFileUrl += "&DownloadKey=" + strOneTimeKey

                let intAction = window.gConst.ACTION_SHARE_FILE_WITH_ANOTHER
                let strQueryString = "Action=" + intAction
                strQueryString += "&Credential="
                strQueryString += "&BackRoute="
                strQueryString += "&FileUrl=" + encodeURIComponent(strFileUrl)
                strQueryString += "&NewFileName=" + encodeURIComponent(mstrDownloadFileName)

                console.log(COMP_NAME + "." + FUNC_NAME + " ACTION_SHARE_FILE_WITH_ANOTHER strQueryString: ", strQueryString)

                // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
                ClientGatewayInPackage.CallApp(strQueryString)
            } // end of else
        } // end of if (ReturnData.FileList.length > 0)
    } // end of GetListeningPDFFileKeyFromFSAfterProcess

    /*===========================================
    summary: 取得Resource 資訊 後續流程
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GetDCPResourceAfterProcess (ReturnData)
    {   
        console.log(COMP_NAME + ".GetDCPResourceAfterProcess")

        mobjResource4FreeResource = ReturnData

        setResourceDataTime(new Date().getTime())
    } // end of GetDCPResourceAfterProcess

    /*===========================================
    summary: 取得授權資料 後續流程
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GetAccountAuthorizedInfoAfterProcess (ReturnData)
    {   
        console.log(COMP_NAME + ".GetAccountAuthorizedInfoAfterProcess")

        marrAuthorizedPackage = ReturnData.AuthorizedPackage

        setAuthorizedDataTime(new Date().getTime())

        if (!mobjCallParam.UpdateAuthorized)
        {
            mobjCallParam = {
                "BookCategoryID": window.gSession.App.BookCatID,
                "BookSeqNo": window.gSession.App.BookSeqNo,
                "ResourceType": ResourceTypeEnum.Free           // 5: ResourceType Free 
            }
            GetDCPResource()
        }
        else
        {
            mobjCallParam = null
        }
    } // end of GetAccountAuthorizedInfoAfterProcess

    /*===========================================
    summary: 輸入授權碼 後續流程 
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function AuthProvisioningAfterProcess ()
    {   
        console.log(COMP_NAME + ".AuthProvisioningAfterProcess")

        let objAlertObject = {
            Header: "",
            Body: window.gAppUI.MSG_SubmitSuccess,
            ShowCloseButton: false,
            CallbackRef: SubmitSuccessAlertCallBack,
            Buttons: [
                {
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }
            ]
        }
        ShowAlert(objAlertObject)

        mobjCallParam = null
    } // end of AuthProvisioningAfterProcess
    // #endregion Web Service After Process

    // #region Web Service 
    /*===========================================
    summary: 輸入授權碼
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function AuthProvisioning ()
    {
        console.log(COMP_NAME + ".AuthProvisioning")

        let objRetryFuncRef = AuthProvisioning
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = AuthProvisioningCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_AuthProvisioning)

            let objCallData = {
                "Func": "AuthProvisioning",
                "AuthCode": mobjCallParam.AuthCode
            };

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of AuthProvisioning

    /*===========================================
    summary: 輸入授權碼 Callback
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function AuthProvisioningCallback (Return)
    {
        console.log(COMP_NAME + ".AuthProvisioningCallback")
        
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_AuthProvisioning_No
        let strErrorTitle = window.gAppUI.ERR_AuthProvisioning_Title
        let strErrMsg = window.gAppUI.ERR_AuthProvisioning_Msg

        let blnExceptionError = false
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                case window.gConst.WEB_GATEWAY_RETURN_ERR_AUTH_PROVISIONING_PROVISONED:         // -120055 已被開通 
                    strErrorTitle = window.gAppUI.ERR_AuthProvisioningRedeemed_Title
                    strErrMsg = '(' + window.gAppUI.ERR_AuthProvisioningRedeemed_No.toString() + ') ' + window.gAppUI.ERR_AuthProvisioningRedeemed_Msg + ' (' + Return.CalledErrNo + ')'
                    blnExceptionError = true
                    break
                case window.gConst.WEB_GATEWAY_RETURN_ERR_AUTH_PROVISIONING_EXPIRED:            // -120056 已過期
                    strErrorTitle = window.gAppUI.ERR_AuthProvisioningExpire_Title
                    strErrMsg = '(' + window.gAppUI.ERR_AuthProvisioningExpire_No.toString() + ') ' + window.gAppUI.ERR_AuthProvisioningExpire_Msg + ' (' + Return.CalledErrNo + ')'
                    blnExceptionError = true
                    break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            } // end of switch (Return.CalledErrNo)

            if (blnExceptionError)
            {
                // 有需要 另外跳 錯誤訊息
                console.log("AuthProvisioningCallback: ExceptionError")

                let objAlertObject = {
                    Header: strErrorTitle,
                    Body: strErrMsg,
                    ShowCloseButton: false,
                    CallbackRef: null,
                    Buttons: [
                        {
                            Text: PackageVariablesLibs.UISettings.BTN_OK,
                            AutoFocus: true
                        }
                    ]
                }
                ShowAlert(objAlertObject)
            } // end of if (blnExceptionError)

            console.log("AuthProvisioningCallback: ErrNo: ", Return.ErrNo)
            console.log("AuthProvisioningCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("AuthProvisioningCallback Return.Data: ", Return.Data)

            AuthProvisioningAfterProcess()
        }
    } // end of AuthProvisioningCallback

    /*===========================================
    summary: 取得授權資料
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GetAccountAuthorizedInfo ()
    {
        console.log(COMP_NAME + ".GetAccountAuthorizedInfo")

        let objRetryFuncRef = GetAccountAuthorizedInfo
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetAccountAuthorizedInfoCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetAccountAuthorizedInfo)

            let objCallData = {
                "Func": "GetAccountAuthorizedInfo",
                "DataType": mobjCallParam.DataType
            };

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetAccountAuthorizedInfo

    /*===========================================
    summary: 取得授權資料 Callback
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GetAccountAuthorizedInfoCallback (Return)
    {
        console.log(COMP_NAME + ".GetAccountAuthorizedInfoCallback")
        
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetAccountAuthorizedInfo_No
        let strErrorTitle = window.gAppUI.ERR_GetAccountAuthorizedInfo_Title
        let strErrMsg = window.gAppUI.ERR_GetAccountAuthorizedInfo_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            } // end of switch (Return.CalledErrNo)

            console.log("GetAccountAuthorizedInfoCallback: ErrNo: ", Return.ErrNo)
            console.log("GetAccountAuthorizedInfoCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetAccountAuthorizedInfoCallback Return.Data: ", Return.Data)

            GetAccountAuthorizedInfoAfterProcess(Return.Data)
        }
    } // end of GetAccountAuthorizedInfoCallback

    /*===========================================
    summary: 取得 Resource 資料
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GetDCPResource ()
    {
        console.log(COMP_NAME + ".GetDCPResource")

        let objRetryFuncRef = GetDCPResource
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetDCPResourceCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetDCPResource)

            let objCallData = {
                "Func": "GetDCPResource",
                "BookCategoryID": mobjCallParam.BookCategoryID,
                "BookSeqNo": mobjCallParam.BookSeqNo,
                "ResourceType": mobjCallParam.ResourceType
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetDCPResource

    /*===========================================
    summary: 取得 Resource 資料 Callback
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GetDCPResourceCallback (Return)
    {
        console.log(COMP_NAME + ".GetDCPResourceCallback")
        
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetDCPResource_No
        let strErrorTitle = window.gAppUI.ERR_GetDCPResource_Title
        let strErrMsg = window.gAppUI.ERR_GetDCPResource_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            } // end of switch (Return.CalledErrNo)

            console.log("GetDCPResourceCallback: ErrNo: ", Return.ErrNo)
            console.log("GetDCPResourceCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetDCPResourceCallback Return.Data: ", Return.Data)

            GetDCPResourceAfterProcess(Return.Data)
        }
    } // end of GetDCPResourceCallback

    /*===========================================
    summary: 取得下載PDF用的OntTimeKey
    remarks: 000 Tim 2023/04/19 Create
    ===========================================*/
    function GetListeningPDFFileKeyFromFS()
    {
        let objRetryFuncRef = GetListeningPDFFileKeyFromFS

        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        } // end of if (!window.navigator.onLine)
        else
        {
            let objCallbackFuncRef = GetListeningPDFFileKeyFromFSCallback
            let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_BC_LEANING

            if (window.gSession.App.InApp)
            {
                // App 才在這邊 顯示 讀取資料 LoadingMask
                // Open Loading mask with message
                OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetListeningPDFFileKeyFromFS)
            } // end of if (window.gSession.App.InApp)

            let objCallData = {
                "Func": "GetListeningPDFFileKeyFromFS",
                "FileName": mobjCallParam.FileName,                
            }
            // console.log("GetListeningPDFFileKeyFromFS.objCallData: ", objCallData)
            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef, intWSServerType)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        } // end of else
    } // end of GetListeningPDFFileKeyFromFS

    /*===========================================
    summary: 取得下載PDF用的OntTimeKey Callback
    remarks: 000 Tim 2023/04/19 Create
    ===========================================*/
    function GetListeningPDFFileKeyFromFSCallback(Return)
    {
        // console.log(COMP_NAME + ".GetListeningPDFFileKeyFromFSCallback: ", Return)

        if (window.gSession.App.InApp)
        {
            // App 才在這邊 顯示 讀取資料 LoadingMask
            // Close Loading mask
            CloseLoadingMask()
        } // end of if (window.gSession.App.InApp)

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetListeningPDFFileKeyFromFS_No
        let strErrorTitle = window.gAppUI.ERR_GetListeningPDFFileKeyFromFS_Title
        let strErrMsg = window.gAppUI.ERR_GetListeningPDFFileKeyFromFS_Msg

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    // NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg, strRetryBackRoute, blnReLaunch, strBackRoute)
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            } // end of switch (Return.CalledErrNo)
            console.log("GetListeningPDFFileKeyFromFSCallback: ErrNo: ", Return.ErrNo)
            console.log("GetListeningPDFFileKeyFromFSCallback: CalledErrNo: ", Return.CalledErrNo)
        } // end of if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        else
        {
            console.log("GetListeningPDFFileKeyFromFSCallback Return.Data: ", Return.Data)

            GetListeningPDFFileKeyFromFSAfterProcess(Return.Data)
        } // end of else
    } // end of GetListeningPDFFileKeyFromFSCallback
    // #endregion Web Service 

    // #region Render元件
    /*===========================================
    summary: Volume Button 顯示Component  
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function ComponentVolumeButton( {Button} )
    {
        return(
            <div className={cssResource.divButton}>
                {Button}
            </div>
        )
    } // end of ComponentVolumeButton

    /*===========================================
    summary: Volume Expire Time 顯示Component  
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function ComponentVolumeExpireTime( {Time} )
    {
        return(
            <div className={cssResource.divVolumeExpireTime}>
                {Time}
            </div>
        )
    } // end of ComponentVolumeExpireTime

    /*===========================================
    summary: Volume Expire Date 顯示Component  
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function ComponentVolumeExpireDate( {Date} )
    {
        return(
            <div className={cssResource.divVolumeExpireDate}>
                {Date}
            </div>
        )
    } // end of ComponentVolumeExpireDate
                
    /*===========================================
    summary: Volume ExpireBy 顯示Component  
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function ComponentVolumeExpireBy( {ExpireBy} )
    {
        return(
            <div className={cssResource.divVolumeExpireBy}>
                {ExpireBy}
            </div>
        )
    } // end of ComponentVolumeExpireBy

    /*===========================================
    summary: Volume Tilte 顯示Component  
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function ComponentVolumeTilte( {BookName} )
    {
        return(
            <div className={cssResource.divVolumeTilte}>
                {BookName}
            </div>
        )
    } // end of ComponentVolumeTilte

    /*===========================================
    summary: Content Authorization Memo 顯示Component  
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function ComponentAuthorizationMemo()
    {
        return(
            <div className={cssResource.divMemoText}>
                {window.gAppUI.LBL_AuthorizationMemo}
            </div>
        )
    } // end of ComponentAuthorizationMemo

    /*===========================================
    summary: Content Submit Button 顯示Component  
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function ComponentSubmitButton()
    {
        return(
            <div className={cssResource.btnSubmit} onClick={() => SubmitOnTapHandler()}>
                {window.gAppUI.BTN_Submit}
            </div>
        )
    } // end of ComponentSubmitButton

    /*===========================================
    summary: Content Title Row 顯示Component  
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function ComponentContentTitleRow( {Title, TitleLineCls} )
    {
        return(
            <>
                <div className={cssResource.divTitleMain}>
                    <div className={cssResource.divContentTitle}>
                        {Title}
                    </div>
                </div>

                <div className={TitleLineCls}/>
            </>
        )
    } // end of ComponentContentTitleRow

    /*===========================================
    summary: Menu Button 顯示Component  
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function ComponentMenuButton( {StateMenuType, DisplayMenuType} )
    {   
        let objDisplay = GetMenuButtonDisplayObject(DisplayMenuType)

        return(
            <div className={GetMenuButtonCls(StateMenuType, DisplayMenuType)} onClick={() => MenuButtonOnTapHandler(DisplayMenuType)}>
                <div className={objDisplay.IconCls}/>
                <div className={cssResource.divMenuButtonText}>
                    {objDisplay.Text}
                </div>
            </div>
        )
    } // end of ComponentMenuButton

    /*===========================================
    summary: Close Button 顯示Component  
    remarks: 000 Tim 2021/11/17 Create
             001 Tim 2022/01/17 將 Close 感應區改大
    ===========================================*/
    function ComponentCloseButton()
    {   
        return(
            <div className={cssResource.btnCloseMain} onClick={() => CloseOnTapHandler()}>
                <div className={cssResource.btnCloseIcon}/>
            </div>
        )
    } // end of ComponentCloseButton

    /*===========================================
    summary: 標題 顯示Component  
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function ComponentTitle()
    {   
        return(
            <div className={cssResource.divTitle}>
                {window.gAppUI.LBL_Resources}
            </div>
        )
    } // end of ComponentTitle

    /*===========================================
    summary: Close Button 顯示Component  
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function ComponentDisplayName( {DisplayName} )
    {   
        return(
            <div className={cssResource.divDisplayName}>
                {DisplayName}
            </div>
        )
    } // end of ComponentCloseButton
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render 檔案下載 書本 資源列表 視窗 的顯示
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function RenderResourceVolumeWrapper(StateIsShowResourceVolume)
    {
        if (StateIsShowResourceVolume)
        {
            return(
                <ResourceVolume BookSeqNo={mobjShowComponentParam.BookSeqNo}
                    ResourceType={mobjShowComponentParam.ResourceType}
                    CallbackRef={ComponentCallback}/>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderResourceVolumeWrapper

    /*===========================================
    summary: Render Redeemed Volume 內容 的顯示
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function RenderFreeResourceVolumeWrapper(FreeResourceType)
    {
        let objDisplay = GetFreeResourceVolumeDisplayObject(FreeResourceType)

        return (
            <div className={cssResource.divVolumeMain4FreeResource} onClick={() => FreeResourceVolumeOnTapHandler(FreeResourceType)}>
                <div className={objDisplay.Icon}/>

                <div className={cssResource.divWritingTemplateVolumeTitle}>
                    {objDisplay.Title}
                </div>
                
                <div className={cssResource.divButton4WritingTemplate}>
                    {objDisplay.Button}
                </div>
            </div>
        )
    } // end of RenderFreeResourceVolumeWrapper

    /*===========================================
    summary: Render FreeResource SubSection For Others 內容 的顯示
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function RenderFreeResourceSubSection4OthersWrapper()
    {
        return (
            <div className={cssResource.divSubSectionMain}>
                {RenderFreeResourceVolumeWrapper(FreeResourceTypeEnum.EssentialQuestions)}
                {RenderFreeResourceVolumeWrapper(FreeResourceTypeEnum.OnlineUser)}
                {RenderFreeResourceVolumeWrapper(FreeResourceTypeEnum.BookUser)}
                <div className={cssResource.divVolumeMainNull}/>
            </div>
        )
    } // end of RenderFreeResourceSubSection4OthersWrapper

    /*===========================================
    summary: Render FreeResource SubSection For Writing Template 內容 的顯示
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function RenderFreeResourceSubSection4WritingTemplateWrapper()
    {   
        return (
            <div className={cssResource.divSubSectionMain}>
                {RenderFreeResourceVolumeWrapper(FreeResourceTypeEnum.Volume1)}
                {RenderFreeResourceVolumeWrapper(FreeResourceTypeEnum.Volume2)}
                {RenderFreeResourceVolumeWrapper(FreeResourceTypeEnum.Volume3)}
                {RenderFreeResourceVolumeWrapper(FreeResourceTypeEnum.Volume4)}
            </div>
        )
    } // end of RenderFreeResourceSubSection4WritingTemplateWrapper

    /*===========================================
    summary: Render Free Resource 內容 的顯示
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function RenderFreeResourceContentWrapper(StateResourceDataTime)
    {
        if (StateResourceDataTime > 0)
        {
            return (
                <div className={cssResource.divSubContent4FreeResource}>
                    <div className={cssResource.divSectionMain4WritingTemplate}>
                        <ComponentContentTitleRow Title={window.gAppUI.LBL_WritingTemplate}
                            TitleLineCls={cssResource.divTitleLine4WritingTemplate}/>

                        {RenderFreeResourceSubSection4WritingTemplateWrapper()}
                    </div>

                    <div className={cssResource.divSectionMain4Others}>
                        <ComponentContentTitleRow Title={window.gAppUI.LBL_Others}
                            TitleLineCls={cssResource.divTitleLine4Others}/>

                        {RenderFreeResourceSubSection4OthersWrapper()}
                    </div>
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderFreeResourceContentWrapper

    /*===========================================
    summary: Render Redeemed Volume 內容 的顯示
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function RenderRedeemedVolumeWrapper(ResourceType, AuthorizedBookList, BookSeqNo)
    {
        let objDisplay = GetRedeemedVolumeDisplayObject(AuthorizedBookList, BookSeqNo)
        let intBookIndex = parseInt(BookSeqNo) - 1

        return (
            <div className={cssResource.divVolumeMain} onClick={() => RedeemedVolumeOnTapHandler(objDisplay.Button, BookSeqNo, ResourceType)}>
                <div className={GetVolumeIconCls(ResourceType, BookSeqNo)}/>

                <ComponentVolumeTilte BookName={window.gSession.App.BookCategoryDef.Book[intBookIndex].Name} />

                <ComponentVolumeExpireBy ExpireBy={objDisplay.ExpireBy} />
                <ComponentVolumeExpireDate Date={objDisplay.Date} />
                <ComponentVolumeExpireTime Time={objDisplay.Time} />

                <ComponentVolumeButton Button={objDisplay.Button} />
            </div>
        )
    } // end of RenderRedeemedVolumeWrapper

    /*===========================================
    summary: Render Redeemed SubSection 內容 的顯示
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function RenderRedeemedSubSectionWrapper(ResourceType)
    {
        let arrAuthorizedBook = GetAuthorizedBookList(ResourceType)

        return (
            <div className={cssResource.divSubSectionMain}>
                {RenderRedeemedVolumeWrapper(ResourceType, arrAuthorizedBook, 1)}
                {RenderRedeemedVolumeWrapper(ResourceType, arrAuthorizedBook, 2)}
                {RenderRedeemedVolumeWrapper(ResourceType, arrAuthorizedBook, 3)}
                {RenderRedeemedVolumeWrapper(ResourceType, arrAuthorizedBook, 4)}
            </div>
        )
    } // end of RenderRedeemedSubSectionWrapper

    /*===========================================
    summary: Render Redeemed 內容 For Teacher 的顯示
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function RenderRedeemedContent4TeacherWrapper()
    {
        if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            return (
                <>
                    <div className={cssResource.divSectionMain4WorkbookAnswerKey}>
                        <ComponentContentTitleRow Title={window.gAppUI.LBL_WorkBookAnswerKey}
                            TitleLineCls={cssResource.divTitleLine4WorkbookAnswerKey}/>

                        {RenderRedeemedSubSectionWrapper(ResourceTypeEnum.WorkbookAnswerKey)}
                    </div>

                    <div className={cssResource.divSectionMain4Assessment}>
                        <ComponentContentTitleRow Title={window.gAppUI.LBL_Assessment}
                            TitleLineCls={cssResource.divTitleLine4Assessment}/>

                        {RenderRedeemedSubSectionWrapper(ResourceTypeEnum.Assessment)}
                    </div>
                </>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderRedeemedContent4TeacherWrapper

    /*===========================================
    summary: Render Code Input 內容 的顯示

             輸入框[<input] 使用 Component 傳 State變數 進去
             去包成 小單元
             會造成 Bug
             App 使用時 按下小鍵盤 輸入一個字 就會 將鍵盤縮下去~
             推測 Component 傳入 State 會有 自己的 PaintedMe, cleanup 與 重新 Render 機制
             導致 裡面 的 html 重新 Render 產生的 Bug

    remarks: 000 Tim 2023/09/06 從 Component 修改成 Render Function
    ===========================================*/
    function RenderCodeInputWrapper(TextID)
    {   
        let strID = "TxtCode0" + TextID.toString()
        let strInputValue = ""
        switch (TextID) 
        {
            case 2:
                strInputValue = code02InputValue
                break
            case 3:
                strInputValue = code03InputValue
                break
            case 4:
                strInputValue = code04InputValue
                break
            case 1:
            default:
                strInputValue = code01InputValue
                break
        } // end of switch

        return(
            <>
                <label htmlFor={strID} className={cssResource.divHidden}>
                    {window.gAppUI.LBL_Label}
                </label>

                <input id={strID} className={cssResource.txtCode}
                    type="text" 
                    value={strInputValue}
                    onChange={(event) => CodeChangeHandler(event, TextID)}
                    maxLength={MAX_CODE_CHARACHERS}
                    required
                />
            </>
        )
    } // end of RenderCodeInputWrapper
    
    /*===========================================
    summary: Render Redeemed 內容 的顯示
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function RenderRedeemedContentWrapper(StateAuthorizedDataTime)
    {
        if (StateAuthorizedDataTime > 0)
        {
            return (
                <div className={cssResource.divSubContent}>
                    <div className={cssResource.divSectionMain}>
                        <ComponentContentTitleRow Title={window.gAppUI.LBL_AuthorizationCode}
                            TitleLineCls={cssResource.divTitleLine4AuthorizationCode}/>
                        
                        <div className={cssResource.divCodeMain}>
                            {RenderCodeInputWrapper(1)}
                            {RenderCodeInputWrapper(2)}
                            {RenderCodeInputWrapper(3)}
                            {RenderCodeInputWrapper(4)}
                            {/* <ComponentCodeInput TextID={1} />
                            <ComponentCodeInput TextID={2} />
                            <ComponentCodeInput TextID={3} />
                            <ComponentCodeInput TextID={4} /> */}

                            <ComponentSubmitButton />
                        </div>

                        <ComponentAuthorizationMemo />
                    </div>

                    <div className={cssResource.divSectionMain4Textbook}>
                        <ComponentContentTitleRow Title={window.gAppUI.LBL_TextBookAudio}
                            TitleLineCls={cssResource.divTitleLine4Textbook}/>

                        {RenderRedeemedSubSectionWrapper(ResourceTypeEnum.Textbook)}
                    </div>

                    <div className={cssResource.divSectionMain4Workbook}>
                        <ComponentContentTitleRow Title={window.gAppUI.LBL_WorkBookAudio}
                            TitleLineCls={cssResource.divTitleLine4Workbook}/>

                        {RenderRedeemedSubSectionWrapper(ResourceTypeEnum.Workbook)}
                    </div>

                    {RenderRedeemedContent4TeacherWrapper()}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderRedeemedContentWrapper

    /*===========================================
    summary: Render 右方 內容 的顯示
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function RenderSubContentWrapper(StateMenuType)
    {
        let objSubContentBlock = ""
        switch (StateMenuType)
        {
            case MenuTypeEnum.FreeResource:   
                objSubContentBlock = RenderFreeResourceContentWrapper(resourceDataTime)
                break
            case MenuTypeEnum.Redeemed:
            default:
                objSubContentBlock = RenderRedeemedContentWrapper(authorizedDataTime)
                break
        } // end of switch (StateMenuType)

        return (
            <div>
                {objSubContentBlock}
            </div>
        )
    } // end of RenderSubContentWrapper

    /*===========================================
    summary: Render 左方 選單 的顯示
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function RenderMenuWrapper(StateMenuType)
    {
        return (
            <div className={cssResource.divMenu}>
                <ComponentMenuButton StateMenuType={StateMenuType} DisplayMenuType={MenuTypeEnum.Redeemed}/>
                <ComponentMenuButton StateMenuType={StateMenuType} DisplayMenuType={MenuTypeEnum.FreeResource}/>
            </div>
        )
    } // end of RenderMenuWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <div className={cssResource.divContent}>
                {RenderMenuWrapper(menuType)}
                {RenderSubContentWrapper(menuType)}
            </div>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 上方工具列 的顯示
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function RenderTopToolWrapper()
    {
        return (
            <div className={cssResource.divTopTool}>
                <ComponentDisplayName DisplayName={mstrDisplayName}/>

                <ComponentTitle />
                
                <ComponentCloseButton />
            </div>
        )
    } // end of RenderTopToolWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssResource.divMain}>
                {RenderTopToolWrapper()}
                
                {RenderContentWrapper()}

                <LoadingMask ShowMask={showLoadingMask} Message={loadingMaskMessage} />
                <AlertWindow ShowAlert={showAlert} AlertObject={alertObject} HideAlertFuncRef={HideAlert} />
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}

            {RenderResourceVolumeWrapper(isShowResourceVolume)}
        </>
    )
    // #endregion Render
}
export default Resource